import { render, staticRenderFns } from "./noPage.vue?vue&type=template&id=e59a63c8&scoped=true"
import script from "./noPage.vue?vue&type=script&lang=js"
export * from "./noPage.vue?vue&type=script&lang=js"
import style0 from "./noPage.vue?vue&type=style&index=0&id=e59a63c8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e59a63c8",
  null
  
)

export default component.exports